import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { microActivityList } from "constants/microActivity";

export const getMicroActivityList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.microActivity_list(pageNum, filters);
    dispatch({ type: microActivityList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: microActivityList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
